import {createContext as $jckr1$createContext, useState as $jckr1$useState, useCallback as $jckr1$useCallback, useEffect as $jckr1$useEffect, useContext as $jckr1$useContext} from "react";
import $jckr1$immutabilityhelper from "immutability-helper";
import $jckr1$macrostrathyper from "@macrostrat/hyper";




const $a4272b5b807f393c$export$7bb606b28f318c99 = (0, $jckr1$createContext)(null);
function $a4272b5b807f393c$export$8664be80ce30e576(props) {
    /*
  Context to assist with editing a model
  */ let { model: model, logUpdates: logUpdates = false, children: children, alwaysConfirm: alwaysConfirm = false } = props;
    console.warn(`Using the ModelEditorContext from
    @macrostrat/column-components is deprecated.
    Please use the equivalent class from
    @macrostrat/ui-components instead.`);
    const [editedModel, setState] = (0, $jckr1$useState)(model);
    // Our model can be initially null, but we want the edited model
    // to take on the first non-null value
    const confirmChanges = ()=>props.onConfirmChanges(editedModel);
    // Zero out edited model when model prop changes
    const revertChanges = (0, $jckr1$useCallback)(()=>{
        if (model == editedModel) return;
        if (alwaysConfirm && editedModel != null) {
            console.log("Confirming model changes");
            confirmChanges();
        }
        setState(model);
    }, [
        model
    ]);
    (0, $jckr1$useEffect)(()=>{
        revertChanges();
    }, [
        model
    ]);
    const updateModel = (0, $jckr1$useCallback)(function(spec) {
        const v = (0, $jckr1$immutabilityhelper)(editedModel, spec);
        if (logUpdates) console.log(v);
        return setState(v);
    }, [
        logUpdates,
        editedModel
    ]);
    const deleteModel = function() {
        setState(null);
        return props.onDelete(model);
    };
    const hasChanges = ()=>model === editedModel;
    const value = {
        model: model,
        editedModel: editedModel,
        updateModel: updateModel,
        deleteModel: deleteModel,
        hasChanges: hasChanges,
        revertChanges: revertChanges,
        confirmChanges: confirmChanges
    };
    return (0, $jckr1$macrostrathyper)($a4272b5b807f393c$export$7bb606b28f318c99.Provider, {
        value: value
    }, children);
}
const $a4272b5b807f393c$export$862ca33d4f264f44 = ()=>(0, $jckr1$useContext)($a4272b5b807f393c$export$7bb606b28f318c99);


//# sourceMappingURL=model-editor.5c344fb1.js.map
